(() => {
  // Diyanet official holiday calendars, verified 2026–2035. Half-day holidays
  // are excluded as whole delivery days so they cannot shorten the estimate.
  const holidayPeriods = {
    2026: [['03-19', 4], ['05-26', 5]],
    2027: [['03-08', 4], ['05-15', 5]],
    2028: [['02-25', 4], ['05-04', 5]],
    2029: [['02-13', 4], ['04-23', 5]],
    2030: [['02-03', 4], ['04-12', 5]],
    2031: [['01-23', 4], ['04-01', 5]],
    2032: [['01-13', 4], ['03-21', 5]],
    2033: [['01-01', 4], ['03-10', 5], ['12-22', 4]],
    2034: [['02-28', 5], ['12-11', 4]],
    2035: [['02-17', 5], ['11-30', 4]]
  };
  const fixedHolidays = new Set(['01-01', '04-23', '05-01', '05-19', '07-15', '08-30', '10-28', '10-29']);
  const religiousHolidays = new Set();
  Object.entries(holidayPeriods).forEach(([year, periods]) => {
    periods.forEach(([start, length]) => {
      const date = new Date(`${year}-${start}T12:00:00Z`);
      for (let i = 0; i < length; i++) {
        religiousHolidays.add(date.toISOString().slice(0, 10));
        date.setUTCDate(date.getUTCDate() + 1);
      }
    });
  });
  function expectedDelivery(now, days) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
    const businessDays = Math.max(1, Math.trunc(Number(days)) || 2);
    let counted = 0;
    while (counted < businessDays) {
      date.setUTCDate(date.getUTCDate() + 1);
      // Keep the generic business-day message if the verified calendar expires.
      if (!holidayPeriods[date.getUTCFullYear()]) return null;
      const iso = date.toISOString().slice(0, 10);
      const weekday = date.getUTCDay();
      if (weekday !== 0 && weekday !== 6 && !fixedHolidays.has(iso.slice(5)) && !religiousHolidays.has(iso)) counted++;
    }
    return date;
  }
  function refreshDates() {
    const now = new Date();
    document.querySelectorAll('[data-delivery-days]').forEach(note => {
      const target = note.querySelector('[data-delivery-date]');
      if (!target) return;
      const days = Number(note.dataset.deliveryDays);
      const date = expectedDelivery(now, days);
      if (date) {
        target.textContent = new Intl.DateTimeFormat('tr-TR', {
          timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
        }).format(date);
        target.setAttribute('datetime', date.toISOString().slice(0, 10));
      } else {
        target.textContent = `${days} iş günü içinde`;
        target.removeAttribute('datetime');
      }
      note.hidden = false;
    });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-lamaa-pdp]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const gallery = root.querySelector('[data-gallery]');
      const slides = [...root.querySelectorAll('.shop-image-zoom-wrapper')];
      let active = 0;
      function show(index) {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          if (i !== active) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        gallery.querySelectorAll('[data-thumb],[data-dot]').forEach(el => {
          const selected = Number(el.dataset.index) === active;
          el.classList.toggle('active', selected);
          if (el.hasAttribute('role')) el.setAttribute('aria-current', String(selected));
        });
      }
      if (gallery) {
        gallery.querySelectorAll('[data-thumb],[data-dot]').forEach(el => {
          el.addEventListener('click', () => show(Number(el.dataset.index)));
          el.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(Number(el.dataset.index)); }
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault(); show(active + (e.key === 'ArrowRight' ? 1 : -1));
              gallery.querySelector(`[data-thumb][data-index="${active}"]`)?.focus();
            }
          });
        });
        gallery.querySelectorAll('[data-gal-prev]').forEach(el => el.addEventListener('click', () => show(active - 1)));
        gallery.querySelectorAll('[data-gal-next]').forEach(el => el.addEventListener('click', () => show(active + 1)));
        let start;
        gallery.addEventListener('touchstart', e => { start = e.changedTouches[0].clientX; }, { passive: true });
        gallery.addEventListener('touchend', e => {
          const distance = e.changedTouches[0].clientX - start;
          if (Math.abs(distance) > 60) show(active + (distance < 0 ? 1 : -1));
        }, { passive: true });
        show(0);
      }
      const form = root.querySelector('.wc-product-form');
      const button = root.querySelector('[data-atc]');
      const select = root.querySelector('[data-lamaa-variant]');
      if (select && button) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        root.querySelector('[data-variant-id]').value = option.value;
        const enabled = root.dataset.canBuy === 'true' && option.dataset.available === 'true';
        button.disabled = !enabled;
        if (enabled) {
          root.querySelector('[data-price]').textContent = option.dataset.price;
          root.querySelector('[data-bundle-price]').textContent = option.dataset.price;
          const total = root.querySelector('[data-offer-total]');
          if (total) total.textContent = option.dataset.price;
          const compare = Number(option.dataset.compareCents);
          const price = Number(option.dataset.cents);
          root.querySelectorAll('[data-compare]').forEach(el => {
            el.hidden = compare <= price;
            el.textContent = option.dataset.compare;
          });
          const saving = root.querySelector('[data-save]');
          if (saving) {
            saving.hidden = compare <= price;
            if (compare > price) root.querySelector('[data-save-pct]').textContent = `%${Math.round((compare - price) / compare * 100)}`;
          }
        }
      });
      // A native Shopify product form keeps the displayed variant price and checkout in sync.
      form?.addEventListener('submit', event => {
        if (root.dataset.canBuy !== 'true' || button?.disabled) event.preventDefault();
      });
    });
    scope.querySelectorAll('.store-faq-section .faq-container').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const close = item => {
        item.classList.remove('active');
        item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        item.querySelector('.faq-answer').hidden = true;
      };
      box.querySelectorAll('.faq-question').forEach(question => question.addEventListener('click', () => {
        const item = question.closest('.faq-item');
        const wasOpen = item.classList.contains('active');
        if (box.dataset.accordion === 'true') box.querySelectorAll('.faq-item').forEach(close);
        if (wasOpen) close(item);
        else {
          item.classList.add('active');
          question.setAttribute('aria-expanded', 'true');
          item.querySelector('.faq-answer').hidden = false;
        }
      }));
    });
    scope.querySelectorAll('.lm-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    scope.querySelectorAll('[data-moving-banner]').forEach(banner => {
      if (banner.dataset.ready) return;
      banner.dataset.ready = 'true';
      const pause = banner.querySelector('[data-banner-pause]');
      pause.addEventListener('click', () => {
        const paused = banner.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? 'Duyuru animasyonunu sürdür' : 'Duyuru animasyonunu duraklat');
        pause.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
    refreshDates();
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshDates(); });
  setInterval(refreshDates, 60000);
})();
